import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';

import WidgetHeader from '@src/modules/Dashboard/WidgetHeader';
import TargetBlankLink from '@src/components/common/TargetBlankLink';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import { DocumentationLink } from '@modules/common/components/docs';

function Header() {
  return (
    <StyledHeaderWrapper>
      <WidgetHeader>OAuth clients</WidgetHeader>
      <Popup
        trigger={<Icon name="question circle outline" size="large" style={{ cursor: 'pointer' }} />}
        content={
          <div>
            OAuth clients for authentication.{' '}
            <TargetBlankLink href={DocumentationLink.OAUTH_CLIENTS}>Learn more</TargetBlankLink>.{' '}
          </div>
        }
        hoverable
        basic
      />
    </StyledHeaderWrapper>
  );
}

export default Header;

const StyledHeaderWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
